import { ADMIN_BASE_PATH } from 'routes/constants/adminPaths';

export const ORG_ONBOARDING_BASE = `${ADMIN_BASE_PATH}/org-onboarding`;

const toSlug = (value: string): string => value.trim().toLowerCase().replace(/\s+/g, '-');

export type OrgOnboardingStep =
  | 'home'
  | 'new'
  | 'uploadUnit'
  | 'unitsReview'
  | 'selectUnit'
  | 'payrollPlan'
  | 'payrollPlanReview'
  | 'sendInvite'
  | 'finchPending';

/** Route pattern constants (for React Router `path` props). */
export const orgOnboardingRoutePatterns = {
  home: ORG_ONBOARDING_BASE,
  newOrg: `${ORG_ONBOARDING_BASE}/new`,
  uploadUnit: `${ORG_ONBOARDING_BASE}/:orgName`,
  unitsReview: `${ORG_ONBOARDING_BASE}/:orgName/units-review`,
  selectUnit: `${ORG_ONBOARDING_BASE}/:orgName/select-unit`,
  payrollPlan: `${ORG_ONBOARDING_BASE}/:orgName/:unitId/payroll-plan`,
  payrollPlanReview: `${ORG_ONBOARDING_BASE}/:orgName/:unitId/payroll-plan-review`,
  sendInvite: `${ORG_ONBOARDING_BASE}/:orgName/:unitId/send-invite`,
  finchPending: `${ORG_ONBOARDING_BASE}/:orgName/:unitId/finch-pending`,
} as const;

const withOrgIdQuery = (path: string, orgId: string): string => {
  const id = orgId.trim();
  if (!id) return path;
  return `${path}?orgId=${encodeURIComponent(id)}`;
};

export const orgOnboardingPaths = {
  home: ORG_ONBOARDING_BASE,
  newOrg: `${ORG_ONBOARDING_BASE}/new`,

  getUploadUnitPath: (orgName: string, orgId: string): string =>
    withOrgIdQuery(`${ORG_ONBOARDING_BASE}/${encodeURIComponent(toSlug(orgName))}`, orgId),

  getUnitsReviewPath: (orgName: string, orgId: string): string =>
    withOrgIdQuery(
      `${ORG_ONBOARDING_BASE}/${encodeURIComponent(toSlug(orgName))}/units-review`,
      orgId
    ),

  getSelectUnitPath: (orgName: string, orgId: string): string =>
    withOrgIdQuery(
      `${ORG_ONBOARDING_BASE}/${encodeURIComponent(toSlug(orgName))}/select-unit`,
      orgId
    ),

  getPayrollPlanPath: (orgName: string, orgId: string, unitId: string): string =>
    withOrgIdQuery(
      `${ORG_ONBOARDING_BASE}/${encodeURIComponent(toSlug(orgName))}/${encodeURIComponent(unitId)}/payroll-plan`,
      orgId
    ),

  getPayrollPlanReviewPath: (orgName: string, orgId: string, unitId: string): string =>
    withOrgIdQuery(
      `${ORG_ONBOARDING_BASE}/${encodeURIComponent(toSlug(orgName))}/${encodeURIComponent(unitId)}/payroll-plan-review`,
      orgId
    ),

  getSendInvitePath: (orgName: string, orgId: string, unitId: string): string =>
    withOrgIdQuery(
      `${ORG_ONBOARDING_BASE}/${encodeURIComponent(toSlug(orgName))}/${encodeURIComponent(unitId)}/send-invite`,
      orgId
    ),

  getFinchPendingPath: (orgName: string, orgId: string, unitId: string): string =>
    withOrgIdQuery(
      `${ORG_ONBOARDING_BASE}/${encodeURIComponent(toSlug(orgName))}/${encodeURIComponent(unitId)}/finch-pending`,
      orgId
    ),
} as const;

export { toSlug as orgNameToSlug };
